<template>
	<div>
		<h1>{{$t('absences')}}</h1>
		<div class="list-group">
			<div
				class="list-group-item"
				v-for="(absence, index) in absences"
				v-bind:key="index"
			>
				<p class="mb-0"><strong>{{absence.ttsessiontype_name}} | {{absence.ttroom_name}}</strong></p>
				<p class="mb-0">{{absence.ttevent_notes}}</p>
				<p class="mb-0">{{$datetime.timestampToDate(absence.ttevent_datetimefrom)}} {{$datetime.timestampToTime(absence.ttevent_datetimefrom, false)}} - {{$datetime.timestampToTime(absence.ttevent_datetimeto, false)}}</p>
				<p class="mb-0">
					{{absence.displayName}}
					<template v-if="absence.studentid"> | {{ $t('id-colon') }} {{ absence.studentid }}</template>
					<template v-if="absence.programme"> | {{ $t('programme-colon') }} {{ $config.getProgrammeNameById(absence.programme) }}</template>
					<template v-if="absence.year">
						<button class="btn btn-light btn-sm ml-2" @click="inspectYear(absence)">{{ $t('year-colon') }} {{ absence.year }}</button>
					</template>
					<template v-if="absence.group">
					<button class="btn btn-light btn-sm ml-2" @click="inspectGroup(absence)">{{ $t('group-colon') }}{{ $config.getGroupNameById(absence.group) }}</button>
					</template>
					<template v-if="absence.firm">
						<button class="btn btn-light btn-sm ml-2" @click="inspectFirm(absence)">{{ $t('firm-colon') }} {{ $config.getFirmNameById(absence.firm) }}</button>
					</template>
				</p>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	components: {
	},
	data() {
		return {
			absences: []
		}
	},
	mounted() {
		this.getAbsences();
	},
	methods: {
		getAbsences: function() {

			this.$cfetch(
			`${this.$settings.APIBaseURL}/timetable/register/gettimetableabsences` , {
				data: {
				}
			}
			).then((json) => {
				if (json.status === "SUCCESS") {
					this.absences = json.result;
				}
			});

		},
		inspectYear(absence){
			this.$router.push(`/timetables/edit/${absence.tttimetable_id}?programme=${absence.programme}&year=${absence.year}&time=${absence.ttevent_datetimefrom}`);
		},
		inspectGroup(absence){
			this.$router.push(`/timetables/edit/${absence.tttimetable_id}?programme=${absence.programme}&year=${absence.year}&group=${absence.group}&time=${absence.ttevent_datetimefrom}`);
		},
		inspectFirm(absence){
			this.$router.push(`/timetables/edit/${absence.tttimetable_id}?programme=${absence.programme}&year=${absence.year}&firm=${absence.firm}&time=${absence.ttevent_datetimefrom}`);
		}
	}
};
</script>
